window.addEventListener('load', () => {
    const accounts = document.querySelectorAll('[data-popup-account]');
    if (!accounts) return;
    accounts.forEach((account) => {
        account.addEventListener('click', (e) => {
            e.preventDefault();
            const checkScrollTop = setInterval(() => {
                const scrollPosition = window.scrollY || document.documentElement.scrollTop;
            const customerDrawer = document.querySelector("customer-drawer");
                if (customerDrawer) {
                    const topPosition = customerDrawer.getBoundingClientRect().top;
                    console.log('topPosition', topPosition);
                    console.log('scrollPosition', scrollPosition);
                    
                    if (scrollPosition > document.querySelector('.rocket-announcement_bar').offsetHeight) {
                        customerDrawer.classList.add("drawer-full-height");
                    } else {
                        customerDrawer.classList.remove("drawer-full-height");
                    }
                }
                clearInterval(checkScrollTop);
                if (document.querySelector("customer-drawer").classList.value.indexOf("is-open") > -1) {
                    document.body.classList.remove("fix");
                    document.body.classList.remove('not-scroll');
                    document.querySelector("customer-drawer").classList.remove("is-open");
                    document.getElementById("closeHamburguerMobile").style.display = 'none';
                    document.getElementById("openHamburguerMobile").style.display = 'block';
                    document.getElementById("closeDrawerCustomerMobile").style.display = 'none';
                } else {
                    document.body.classList.add("fix");
                    document.querySelector("customer-drawer").classList.add("is-open");
                    document.getElementById("closeHamburguerMobile").style.display = 'block';
                    document.getElementById("openHamburguerMobile").style.display = 'none';
                    document.getElementById("closeDrawerCustomerMobile").style.display = 'none';
                }
                document.getElementById("page-algolia-container").classList.remove("is-open");
                document.getElementById("mainMenu").classList.remove("open");
                document.getElementById("menuOverlay").classList.remove("open");
                document.querySelector("cart-drawer").classList.remove("is-open");
                if(e.target.classList.contains('benefits-table__button-regis')) {
                    window.location.hash = '#register_popup';
                }

                if(e.target.classList.contains('benefits-table__button-login')) {
                    window.location.hash = '#login_popup';
                }
            }, 10);
        });
    })
});
class CustomerDrawer extends HTMLElement {
    constructor() {
      super();
      document.getElementById("closeDrawerCustomerMobile").addEventListener('click', () => {
        document.querySelector('.rocket-announcement_bar').classList.remove('not-show-desktop');
        this.close();
      });
      this.querySelector('#customerDrawer-Overlay').addEventListener('click', this.close.bind(this));
      document.addEventListener('pointerdown', this.handleOutsideClick.bind(this));
    }
  
    close() {
      document.querySelector("customer-drawer .drawer__close").click();
      this.classList.remove('is-open');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('fix');
      document.querySelector("customer-drawer").classList.remove('is-open');
      setTimeout(() => {
        document.getElementById("openHamburguerMobile").style.display = 'block';
        document.getElementById("closeHamburguerMobile").style.display = 'none';
        document.getElementById("closeDrawerCustomerMobile").style.display = 'none';
      },300)
    }
    // handleOutsideClick(event) {
    //     let isClickInside = this.contains(event.target) || event.target.closest('#customerDrawer-Overlay');

    //     if (!isClickInside && this.classList.contains('is-open')) {
    //         this.close();
    //     }
    // }
  }
  
customElements.define('customer-drawer', CustomerDrawer);

class CustomerForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
        const form = this.closest(".customer__custom");
        this.form.addEventListener("submit", function (event) {
            // event.preventDefault();
            this.error = false;
        
            const emailInput = this.querySelector('[type="email"]');
            const errorEmail = this.querySelector(".field__error-email");
            const messageEmail = errorEmail.getAttribute("data-error");
        
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
            const errorName = this.querySelector(".field__error-name");
            if (errorName) {
                const nameInput = this.querySelector('[name="customer[first_name]"]');
                const messageName = errorName.getAttribute("data-error");
                if (nameInput.value == "") {
                    errorName.textContent = messageName;
                    this.error = true;
                } else {
                    errorName.textContent = "";
                }
            }

            const errorPass = this.querySelector(".field__error-pass");
            if (errorPass) {
                const messagePass = errorPass.getAttribute("data-error");
                const passInput = this.querySelector('[type="password"]');
                if (passInput.value == "") {
                    errorPass.textContent = messagePass;
                    this.error = true;
                } else {
                    errorPass.textContent = "";
                }
            }
        
            if (!emailRegex.test(emailInput.value)) {
                errorEmail.textContent = messageEmail;
                this.error = true;
            } else {
                errorEmail.textContent = "";
            }
            console.log(this.form, form);
            if (this.error) {
                event.preventDefault();
                form.classList.add("has__error");
                return
            } else {
                form.classList.remove("has__error");
                this.form.submit();
            }
        });
    }
}
customElements.define('customer-form', CustomerForm);